import { textures } from "@/config/media";

// One statement line rendered with the texture visible through the
// letterforms via CSS background-clip:text. The paired locked-off loop
// (L01 water) would play inside the letters if browsers exposed video as
// a CSS background — until they do, the still first frame is what shows,
// which reads as "the still that is about to move" and holds on the brand
// idea just as well.
// @supports fallback: solid ink colour.
export default function FilmText({ texture = "T01", children, className = "" }) {
  const t = textures[texture];
  const url = t ? `${t.base}-1600.jpg` : null;
  return (
    <span
      data-testid="film-text"
      className={`film-text ${className}`}
      style={{
        backgroundImage: url ? `url("${url}")` : undefined,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {children}
    </span>
  );
}
